var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Game',{attrs:{"id":"game2","hud-template":_vm.Hud}})
}
var staticRenderFns = []

export { render, staticRenderFns }